import WebGLPointsLayer from 'ol/layer/WebGLPoints.js';
import VectorSource from "ol/source/Vector";
import VectorLayer from 'ol/layer/Vector';
import Draw from 'ol/interaction/Draw'
import ExtentInteraction from 'ol/interaction/Extent.js';
import { shiftKeyOnly } from 'ol/events/condition';
import { Feature } from 'ol';
import { Circle } from 'ol/geom';
import PointerInteraction from 'ol/interaction/Pointer';
import { buffer } from 'ol/extent';


export const pointStaticMap = ({ map, featureCollection, activeLayers, setActiveLayers, selectedRadioOption, mapData, setMapData }) => {
    const colors = ["#0067A3",
                    "#771155", "#AA4488", "#CC99BB", "#114477", "#4477AA", "#77AADD", "#117777", "#44AAAA", "#77CCCC", "#117744",
                    "#44AA77", "#88CCAA", "#777711", "#AAAA44", "#DDDD77", "#774411", "#AA7744", "#DDAA77", "#771122", "#AA4455", 
                    "#DD7788"];

    let vectorSource;
  
    const circleHandle = () => {
        let flag = true;

        const resolution = map.getView().getResolution();
        const circle = new Circle([0, 0], 50*resolution);

        const circleFeature = new Feature(circle);
        const circleSource = new VectorSource({
            features: [circleFeature]
        });

        const circleLayer = new VectorLayer({
            title: "statistics",
            source: circleSource,
            zIndex: 100
        });

        const mouseMoveEvent = (e) => {
            if(flag){
                const coordinate = e.coordinate;
                circle.setCenter(coordinate)
    
                const ext = buffer(circle.getCenter().concat(circle.getCenter()), circle.getRadius());
    
                const features = vectorSource.getFeaturesInExtent(ext);
    
                const insideCircle = features.filter((feature) => {
                    return circle.intersectsExtent(feature.getGeometry().getExtent());
                })
    
                setMapData(insideCircle);
            }
        }

        const mouseClickEvent = (e) => {
            if(e.type === "click") {
                flag = !flag;
                mouseMoveEvent(e);
            }
        }

        const pointer = new PointerInteraction({
            handleMoveEvent: mouseMoveEvent
        });

        const click = new PointerInteraction({
            handleEvent: mouseClickEvent
        })

        pointer.set("title", "statistics");
        click.set("title", "statistics");

        map.addInteraction(click);
        map.addInteraction(pointer);
        map.addLayer(circleLayer);
    };
    
    const extentHandle = () => {
        const extent = new ExtentInteraction({
            condition: shiftKeyOnly
        })

        extent.set("title", "statistics");

        map.addInteraction(extent);

        const extentEvent = (e) => {
            const extent = e.extent;
            
            if(extent) {
                const featuresInExtent = vectorSource.getFeaturesInExtent(extent);
                setMapData(featuresInExtent);
            }
        }

        extent.on("extentchanged", extentEvent);
    };

    const drawHandle = () => {
        const drawSource = new VectorSource();
        const drawLayer = new VectorLayer({
            title: "statistics",
            source: drawSource,
            style: {
                'fill-color': 'rgba(255, 255, 255, 0.2)',
                'stroke-color': '#ffcc33',
                'stroke-width': 2,
            },
            zIndex: 100
        })

        const drawStartEvent = () => {
            if(drawSource.getFeatures().length > 0) {
                drawSource.forEachFeature((feature) => {
                    drawSource.removeFeature(feature)
                })
            }
        }
    
        const drawEndEvent = (e) => {
            const geometry = e.feature.getGeometry();
            const extent = geometry.getExtent();            
            const featuresInExtent = vectorSource.getFeaturesInExtent(extent);
    
            setMapData(featuresInExtent);
        }


        map.addLayer(drawLayer);
        
        const draw = new Draw({
            source: drawSource,
            type: 'Polygon'
        });

        draw.set("title", "statistics");
        
        map.addInteraction(draw);

        draw.on('drawstart', drawStartEvent);
        draw.on('drawend', drawEndEvent);
    };
    

    const mount = () => {
        if(activeLayers) {
            setActiveLayers();
        }

        vectorSource = new VectorSource({});
                
        featureCollection.forEach((data) => {
            data.featureArray.forEach((feature) => {
                const clonedFeature = feature.clone();
                clonedFeature.setProperties({ id: data.id, COLOR: colors[data.id] });
                vectorSource.addFeature(clonedFeature);
            });
        })

        const style = {
            'circle-radius': 2.5,
            'circle-stroke-width': 1,
            'circle-stroke-color': "#fff",
            'circle-opacity': 0.9,
            'circle-fill-color': [
                'case',
                ['==', ['get', 'id'], 1], colors[1],
                ['==', ['get', 'id'], 2], colors[2],
                ['==', ['get', 'id'], 3], colors[3],
                ['==', ['get', 'id'], 4], colors[4],
                ['==', ['get', 'id'], 5], colors[5],
                ['==', ['get', 'id'], 6], colors[6],
                ['==', ['get', 'id'], 7], colors[7],
                ['==', ['get', 'id'], 8], colors[8],
                ['==', ['get', 'id'], 9], colors[9],
                ['==', ['get', 'id'], 10], colors[10],
                ['==', ['get', 'id'], 11], colors[11],
                ['==', ['get', 'id'], 12], colors[12],
                ['==', ['get', 'id'], 13], colors[13],
                ['==', ['get', 'id'], 14], colors[14],
                ['==', ['get', 'id'], 15], colors[15],
                ['==', ['get', 'id'], 16], colors[16],
                ['==', ['get', 'id'], 17], colors[17],
                ['==', ['get', 'id'], 18], colors[18],
                ['==', ['get', 'id'], 19], colors[19],
                ['==', ['get', 'id'], 20], colors[20],
                ['==', ['get', 'id'], 21], colors[21],
                colors[0]
            ]
        };

        const layer = new WebGLPointsLayer({
            source: vectorSource,
            style: style,
            zIndex: 20,
        })

        if(selectedRadioOption === "circle") {
            circleHandle();
        } else if(selectedRadioOption === "draw") {
            drawHandle();
        } else if(selectedRadioOption === "extent") {
            extentHandle();
        }
    
        setActiveLayers([layer]);      
    }

    const dismount = () => {
        const layers = map.getLayers().getArray();
        const statisticsLayer = layers.filter((layer) => layer.get("title") === "statistics");

        const interactions = map.getInteractions().getArray();
        const statisticsInteraction = interactions.filter((interaction) => interaction.get("title") === "statistics");

        if(statisticsInteraction) {
            statisticsInteraction.forEach((interaction) => {
                map.removeInteraction(interaction);
            })
        }

        if(statisticsLayer.length > 0) {
            statisticsLayer.forEach((layer) => {
                map.removeLayer(layer);
            }) 
        }
        setActiveLayers();
        setMapData();
    }

    return { mount: mount, dismount: dismount };
}